import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { UpdateDisplayMessageSettings } from '../model/update-display-message-settings';
import { Observable } from 'rxjs';
import {ApiRouteConfig} from '../../../config/api.route.config';

@Injectable()
export class SettingsService {

  constructor(private http: HttpClient, private config: ApiRouteConfig,) { }

  shouldShowMessage(messageType): Observable<boolean> {
    return this.http.get<any[]>(this.config.BUSINESS_DISPLAYMESSAGESETTINGS, {}).pipe(
      map(set => {
        const messageSettings = set.find(x => x.messageType === messageType);
        if(messageSettings && messageSettings.value === true){
          return false;
        }
        else {
          return true;
        }       
      })
    );
  }

  dontShowAgainMessage(messageType) {
    return this.http.post(this.config.BUSINESS_DISPLAYMESSAGESETTINGS, new UpdateDisplayMessageSettings(messageType, true));
  }

}
